var map = {
	"./about_jewlr.svg": 24547,
	"./contact_us.svg": 2496,
	"./existing_orders.svg": 70984,
	"./general-questions.svg": 21625,
	"./jewelry-education.svg": 22342,
	"./jewlr_education.svg": 51966,
	"./order-information.svg": 43248,
	"./payment_options.svg": 77508,
	"./repair_resize.svg": 26535,
	"./returns.svg": 15684,
	"./rewards.svg": 63625,
	"./shipping.svg": 67041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14403;